<template>
  <a-modal :open="open" @cancel="closeForm" class="modal-no-padding">
    <div class="modal-no-padding__header">
      <h2>Объединение в группу ({{ users.length }})</h2>
    </div>
    <a-divider style="margin: 16px 0" />
    <div class="modal-no-padding__body">
      <a-form-item>
        <a-select
            v-model:value="groupToCopyIn"
            :placeholder="'Не выбрано'"
            :not-found-content="'Нет данных'"
        >
          <a-select-option v-for="e in groups" :key="e.id" :value="e.id">
            {{ e.name }}
          </a-select-option>
        </a-select>

        <a-button type="text" class="add-group-button" v-if="!showNewGroupForm" @click="showNewGroupForm = true">
          <template #icon>
            <PlusOutlined />
          </template>
          Создать группу
        </a-button>

        <a-row v-if="showNewGroupForm">
          <div class="group-form">
            <div class="group-name-input">
              <a-input v-model:value="newGroupName" placeholder="Название группы" />
            </div>
            <a-button :disabled="newGroupIsBeingCreated || !newGroupName" class="group-create-button primary-button" @click="createGroup">
              Создать
            </a-button>
            <a-button @click="showNewGroupForm = false" class="secondary-button">
              <template #icon>
                <CloseOutlined />
              </template>
            </a-button>
          </div>
        </a-row>
      </a-form-item>
    </div>

    <template #footer>
      <a-divider style="margin: 16px 0" />
      <div class="modal-no-padding__footer">
        <div class="action-buttons">
          <a-row justify="end" :gutter="8">
            <a-col>
              <a-button class="secondary-button" @click="closeForm">Отменить</a-button>
            </a-col>
            <a-col>
              <a-button class="primary-button" :loading="modalActionLoading" @click="handleCopyToGroup">Применить</a-button>
            </a-col>
          </a-row>
        </div>
      </div>
    </template>
  </a-modal>
</template>

<script>
import {CloseOutlined, PlusOutlined} from "@ant-design/icons-vue";
import {message} from "ant-design-vue";
import {useStore} from "vuex";
import {computed, ref} from "vue";

export default {
  components: {CloseOutlined, PlusOutlined},
  props: {
    open: Boolean,
    groupList: Array,
    users: Array,
  },
  emits: ['submitted', 'close'],
  setup(props, context) {
    const store = useStore();
    const modalActionLoading = ref(false);
    const groupToCopyIn = ref();
    const allGroups = computed(() => store.state.group.groups);
    const groups = computed(() => {
      const source = allGroups.value?.length ? allGroups.value : props.groupList;

      return (source ?? []).map((group) => {
        return {
          id: group.id,
          name: group.name,
        }
      });
    });
    const showNewGroupForm = ref(false);
    const newGroupIsBeingCreated = ref(false);
    const newGroupName = ref('');
    const newCreatedGroup = computed(() => store.state.group.group);

    const handleCopyToGroup = () => {
      if (!groupToCopyIn.value) {
        return;
      }

      modalActionLoading.value = true;

      store.dispatch('group/addUsersToGroup', {
        groupId: groupToCopyIn.value,
        data: {
          users: props.users
        }
      }).then(() => {
        message.success('Пользователи скопированы');
        context.emit('submitted');
      }).finally(() => {
        modalActionLoading.value = false;
      });
    }

    const closeForm = () => {
      context.emit('close');
    }

    const createGroup = () => {
      newGroupIsBeingCreated.value = true;
      store.dispatch('group/createGroup', {
        name: newGroupName.value,
      }).then(() => {
        newGroupName.value = '';

        store.dispatch("group/getGroups").then(() => {
          groupToCopyIn.value = newCreatedGroup.value?.group?.id;
        });

        showNewGroupForm.value = false;
      }).finally(() => {
        newGroupIsBeingCreated.value = false;
      });
    }

    return {
      groups,
      groupToCopyIn,
      modalActionLoading,
      showNewGroupForm,
      newGroupIsBeingCreated,
      newGroupName,
      createGroup,
      closeForm,
      handleCopyToGroup
    }
  }
}
</script>

<style scoped lang="scss">
  .add-group-button {
    padding-left: 0;
    margin-top: 10px;
    color: var(--main-green);
  }

  .group-form {
    width: 100%;
    margin-top: 10px;
    display: flex;
    column-gap: 5px;

    .secondary-button {
      min-width: 32px;
    }
  }

  .group-name-input {
    width: 100%;
  }
</style>